import { useProductDetailState } from 'contexts';
import { MAX_ITEMS_WITH_TWO_BLOCKS, RelatedBlock } from './RelatedBlock';

export const RelatedPosts = () => {
  const { product } = useProductDetailState();

  const { relatedPosts } = product?.seoInfo || {};

  if (!relatedPosts?.urls?.length) {
    return null;
  }

  return (
    <RelatedBlock
      title={relatedPosts?.title || ''}
      seeMoreUrl={relatedPosts?.seeMoreUrl}
      type="post"
      items={
        relatedPosts?.urls
          ?.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS)
          .map(({ url, thumbnailUrl, description }) => {
            return {
              url: url || '',
              thumbnailUrl: thumbnailUrl || '',
              description: description || '',
            };
          }) || []
      }
    />
  );
};
